const FORMATTED_LINK_PATTERN = /<([^<>|\r\n]+)\|(https?:\/\/[^<>\s]+)>/gi;

import * as linkify from 'linkifyjs';

export type FormattedLinkPart =
  { type: 'text'; value: string } | { type: 'link'; label: string; url: string };

export function parseFormattedLinks(value: string): FormattedLinkPart[] {
  const parts: FormattedLinkPart[] = [];
  let cursor = 0;

  FORMATTED_LINK_PATTERN.lastIndex = 0;
  let match = FORMATTED_LINK_PATTERN.exec(value);
  while (match !== null) {
    const label = match[1].trim();
    let url: URL | null = null;

    try {
      url = new URL(match[2]);
    } catch {
      url = null;
    }

    if (label && url?.hostname && ['http:', 'https:'].includes(url.protocol)) {
      if (match.index > cursor) {
        parts.push({ type: 'text', value: value.slice(cursor, match.index) });
      }
      parts.push({ type: 'link', label, url: match[2] });
      cursor = match.index + match[0].length;
    }

    match = FORMATTED_LINK_PATTERN.exec(value);
  }

  if (cursor < value.length) {
    parts.push({ type: 'text', value: value.slice(cursor) });
  }

  return parts.length ? parts : [{ type: 'text', value }];
}

type LinkifyMatch = {
  type: string;
  href: string;
  start: number;
  end: number;
};

function formatBareLinks(value: string, defaultLabel: string) {
  const matches: LinkifyMatch[] = linkify.find(value);
  let cursor = 0;
  let result = '';

  matches.forEach((match) => {
    let url: URL | null = null;
    try {
      url = new URL(match.href);
    } catch {
      url = null;
    }

    if (match.type === 'url' && url?.hostname && ['http:', 'https:'].includes(url.protocol)) {
      result += value.slice(cursor, match.start);
      result += `<${defaultLabel}|${match.href}>`;
      cursor = match.end;
    }
  });

  return `${result}${value.slice(cursor)}`;
}

export function normalizeWishLinks(value: string, defaultLabel: string) {
  return parseFormattedLinks(value)
    .map((part) =>
      part.type === 'link'
        ? `<${part.label}|${part.url}>`
        : formatBareLinks(part.value, defaultLabel),
    )
    .join('');
}

/** Wait for a word boundary so typing a URL is never interrupted midway. */
export function normalizeCompletedWishLinks(value: string, defaultLabel: string) {
  return /\s$/.test(value) ? normalizeWishLinks(value, defaultLabel) : value;
}
